import React, { useEffect } from 'react';
import './App.css';
import { Title } from './screens/title';
import { Date } from './screens/date';
import { Agenda } from './screens/agenda';
import { Contact } from './screens/contact';
import { Footer } from './screens/footer';
import { Location } from './screens/location';
import { COLOR } from './styles';
import { Hotel } from './screens/hotel';
import { WeddingCarousel } from './screens/carousel';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Checkin } from './screens/checkin';
import ReactGA from 'react-ga';
import { Gift } from './screens/gift';
import { Church } from './screens/church';

function App() {
    const TRACKING_ID = 'G-2BYXP9DDPB'; // OUR_TRACKING_ID
    ReactGA.initialize(TRACKING_ID);

    useEffect(() => {
        console.log('helloooo');
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    element={
                        <div className="App">
                            <div className="screen">
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    <Title />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    <Date />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.GREYWHITE
                                    }}
                                >
                                    {' '}
                                    <Agenda />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    {' '}
                                    <Church />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.GREYWHITE
                                    }}
                                >
                                    {' '}
                                    <Location />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    {' '}
                                    <Hotel />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.GREYWHITE
                                    }}
                                >
                                    {' '}
                                    <WeddingCarousel />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    {' '}
                                    <Contact />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    <Gift />
                                </div>
                                <div
                                    className="screen-wrapper"
                                    style={{
                                        backgroundColor: COLOR.WHITE
                                    }}
                                >
                                    <Footer />
                                </div>
                            </div>
                        </div>
                    }
                ></Route>
                <Route path="checkin" element={<Checkin />}></Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
